import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let routers = [];
// 动态require组件,找到路径
const requireComponent = require.context("../pages/", true, /router.js$/);
requireComponent.keys().forEach((filePath) => {
  // 组件实例
  const componentConfig = requireComponent(filePath);
  routers = routers.concat(componentConfig.router);
});

/* 路由跳转返回顶部 */
const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  } else {
    return new Promise((resolve) => {
      if (to.matched.some((m) => m.meta.scrollToTop)) {
        // chrome
        document.body.scrollTop = 0;
        // firefox
        document.documentElement.scrollTop = 0;
        // safari
        window.pageYOffset = 0;
      }
    });
  }
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior,
  routes: [
    {
      path: "/",
      name: "Layout",
      component: () => import("@/layouts/Index.vue"),
      children: routers,
    },
    {
      path: "/inviteIndex",
      component: () =>
        import("@/pages/system/organizational/user/InviteIndex.vue"),
    },
    {
      path: "/information/program/edit",
      component: () =>
        import("@/pages/information-release/program/Program.vue"),
    },
    {
      path: "/enterpriseCertification",
      component: () => import("@/layouts/enterprise-certification/index.vue"),
    },
    {
      path: "/loginFactor",
      component: () => import("@/pages/login-factor/Index.vue"),
    },
  ],
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
